// extracted by mini-css-extract-plugin
export default {"container":"aspect-ratio-wrapper_container__sb95T"};